import React from "react";
import { skills } from "../../data";
import { BadgeCheckIcon, ChipIcon } from "@heroicons/react/solid";

export default function Skills() {
  return (
    <section id="skills" className="text-gray-300 bg-gray-900 body-font py-20 border-t border-b border-gray-800">
      <div className="container px-5 mx-auto max-w-5xl">
        <div className="text-center mb-16">
          <ChipIcon className="w-10 h-10 inline-block mb-4 text-green-400" />
          <h2 className="sm:text-4xl text-3xl font-bold title-font mb-4 text-white">
            Core Competencies &amp; Technical Stack
          </h2>
          <p className="text-gray-400 text-lg leading-relaxed xl:w-2/4 lg:w-3/4 mx-auto">
            From modern frontend frameworks and state management to headless CMS architectures and creative UI/UX prototyping.{" "}
            <a
              href="#contact"
              className="text-green-400 hover:text-green-300 underline font-medium"
            >
              Contact me
            </a>{" "}
            to discuss your tech stack requirements.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {skills.map((skill) => (
            <div
              key={skill}
              className="bg-gray-800/80 hover:bg-gray-800 border border-gray-700/60 hover:border-green-500/40 rounded-xl p-4 flex items-center transition-all duration-200 shadow-sm"
            >
              <BadgeCheckIcon className="text-green-400 w-6 h-6 flex-shrink-0 mr-3" />
              <span className="title-font font-medium text-white text-base">
                {skill}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}